import React from 'react';

import { Modal } from '../../../../components';

import { CryingFace } from '../../../../assets/svg-image/modal';

import {
  OkeyBtn,
} from './Styles';
import SquadBoldText from '../../../../components/Text/SquadBoldText';
import PingFangSemiBoldText from '../../../../components/Text/PingFangSemiBoldText';
import SquadRegularText from '../../../../components/Text/SquadRegularText';
import PingFangRegularText from '../../../../components/Text/PingFangRegularText';
import { closeBlack } from '../../../../assets/Base64Image';

const NoFreeBoxModal: React.FC<Props> = ({
  onClose,
  isEnglish,
}) => {
  return (
    <Modal
      style={{ width: '275px', minWidth: 'unset', padding: 'unset', textAlign: 'center', paddingBottom: 15, borderRadius: 42 }}
    >
      {/* 图标 */}
      <div>
        <img src={CryingFace} style={{ width: '72px', height: '71px', marginTop: '-35px' }} />
      </div>

      {/* 关闭图标 */}
      <div
        onClick={() => onClose()}
        style={{ padding: '10px', width: '30px', height: '30px', marginLeft: 'auto', marginRight: '10px', marginTop: '-35px' }}
      >
        <img src={closeBlack} style={{ width: '14px', height: '14px', marginTop: 8, marginLeft: 18 }} />
      </div>

      {
        isEnglish ? (
          <SquadBoldText fontSize={22}>
            Sorry
          </SquadBoldText>
        ) : (
          <PingFangSemiBoldText fontSize={22}>
            抱歉
          </PingFangSemiBoldText>
        )
      }
      {
        isEnglish ? (
          <SquadRegularText fontSize={16} lineHeight={21} textAlign={'center'} marginTop={15}>
            There are no cubicles available currently, please try again later.
          </SquadRegularText>
        ) : (
          <PingFangRegularText fontSize={16} lineHeight={21} textAlign={'center'} marginTop={15}>
            现在暂时没有可用的智能柜，<br />请稍后再试。
          </PingFangRegularText>
        )
      }

      <OkeyBtn onClick={() => onClose()}>
        {
          isEnglish ? (
            <SquadBoldText fontSize={18} color={'#FFFFFF'}>
              Quit
            </SquadBoldText>
          ) : (
            <PingFangSemiBoldText fontSize={18} color={'#FFFFFF'}>
              退出
            </PingFangSemiBoldText>
          )
        }
      </OkeyBtn>
    </Modal>
  );
};

export interface Props {
  onClose: () => void;
  isEnglish: boolean;
}

export default NoFreeBoxModal;
